// extracted by mini-css-extract-plugin
module.exports = {"guarantorBadge":"badgeStyles_guarantorBadge__3xu4G","guarantorBadgeEnMobile":"badgeStyles_guarantorBadgeEnMobile__2Ecwj"};